import { colors } from "@mui/material";

const color = {
  sidebar: {
    bg: "rgb(0, 18, 25)",
    color: "#eeeeee",
    hoverBg: "#1e293a",
    activeBg: "#1e253a"
  },
  topbar: {
    bg: "#fff",
    color: "#000"
  },
  mainBg: colors.grey["100"]
};

export default color;